import { render, staticRenderFns } from "./CustomKey.vue?vue&type=template&id=78c317aa&scoped=true"
import script from "./CustomKey.vue?vue&type=script&lang=js"
export * from "./CustomKey.vue?vue&type=script&lang=js"
import style0 from "./CustomKey.vue?vue&type=style&index=0&id=78c317aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c317aa",
  null
  
)

/* custom blocks */
import block0 from "./CustomKey.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports